import { FC } from 'react'
import Swal from 'sweetalert2'
import { RowActions, useModal, useToast } from '../../../../../../components'
import {
  FormularioSituacao,
  IconPaths,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { signAvaliacao } from '../../core/_requests'
import { FormularioAtendimentoDtoAssinatura, FormularioAtendimentoList } from '../../core/_models'
import { FormularioViewModal } from '../../components/modal/FormularioViewModal'
import { useCertificado } from '../../../../../../helpers/hooks/useCertificado'
import { getFormularioAtendimento } from '../../../avaliacoes-list/core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'

type Props = {
  formularioAtendimento: FormularioAtendimentoList
}

export const AvaliacoesPendentesActionsCell: FC<Props> = ({ formularioAtendimento }) => {
  const { ensurePassword } = useCertificado()
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const paciente = formularioAtendimento.paciente?.nome ?? ''
  const nome = `Avaliação de ${paciente}`.trim()

  // A senha do certificado já é a confirmação da assinatura (ensurePassword).
  const handleAssinar = async () => {
    try {
      const { ok, tipo } = await ensurePassword()
      if (!ok || !tipo) return

      showAlertLoading()
      const assinatura: FormularioAtendimentoDtoAssinatura = {
        atendimento: Number(formularioAtendimento.atendimento.id),
        formularioAtendimento: Number(formularioAtendimento.id),
        tipo,
      }
      await signAvaliacao(assinatura)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} assinada.` })
      // Assinada sai da lista de pendentes.
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  const showAvaliacao = () =>
    getFormularioAtendimento(formularioAtendimento.atendimento.id, formularioAtendimento.id)
      .then((data) =>
        showModal({
          title: nome,
          content: <FormularioViewModal data={data} />,
        })
      )
      .catch(showError)

  // Só renderizada para médico (a coluna de ações nem existe para os demais — ver _columns).
  // Visualizar só enquanto não assinada.
  const podeVisualizar = formularioAtendimento.situacao !== FormularioSituacao.Assinado

  return (
    <RowActions
      itemName={nome}
      primaryAction={
        podeVisualizar
          ? { label: 'Visualizar', onClick: showAvaliacao, icon: IconPaths.Search }
          : { label: 'Assinar', onClick: handleAssinar }
      }
      items={podeVisualizar ? [{ label: 'Assinar', onClick: handleAssinar }] : []}
    />
  )
}
